import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import {
  mergeAreaChartOptions,
  viChartColors,
} from "../../pages/Compare/chartTheme";

const RevenueGrowthQtrOnQtrTrendLine: React.FC<any> = ({
  data,
}): React.ReactElement => {
  const { series = [], categories = [] } = data || {};
  const calculateTrendLine = (data: any) => {
    const n = data.length;
    let sumX: number = 0;
    let sumY: number = 0;
    let sumXY: number = 0;
    let sumX2: number = 0;

    for (let i = 0; i < n; i++) {
      sumX += i + 1;
      const val = parseFloat(String(data[i]).replace("%", ""));
      sumY += val;
      sumXY += (i + 1) * val;
      sumX2 += (i + 1) * (i + 1);
    }
    console.log({ sumX, sumY, sumXY, sumX2 });
    const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
    const intercept = (sumY - slope * sumX) / n;

    const trendLineData = [];

    for (let i = 0; i < n; i++) {
      trendLineData.push(slope * (i + 1) + intercept);
    }

    return trendLineData;
  };

  const trendLineData = calculateTrendLine(series[0].data);

  const chartData: any = {
    options: mergeAreaChartOptions({
      colors: [viChartColors[2]],
      chart: {
        id: "RevenueGrowthQtrOnQtrTrendLine",
      },
      stroke: {
        curve: ["smooth", "straight"],
        dashArray: [4, 0],
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return value.toFixed(0);
          },
        },
      },
      xaxis: {
        categories,
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [0],
        formatter: (value: string) => {
          return `${value}%`;
        },
        offsetY: -5,
      },
    }),
    chart: {
      type: "line",
    },
    series: [
      {
        name: series[0].name,
        data: series[0].data,
        type: "area",
      },
      {
        name: "Trend Line",
        data: trendLineData,
        type: "line",
        color: "#9BBA8E",
      },
    ],
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">Revenue Growth: Qtr on Qtr (with trendline)</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        height={550}
      />
    </div>
  );
};

export default RevenueGrowthQtrOnQtrTrendLine;
